import { Suggestions } from '@mint-sdk/api-recommendations';
import { atom } from 'jotai';

export const selectedSuggestionAtom =
  atom<Suggestions.SuggestionResponseType | null>(null);
